export enum BANNER_STATUS {
  FREE = 'FREE',
  TRIAL_START = 'TRIAL_START',
  TRIAL_NEAR_END = 'TRIAL_NEAR_END',
  TRIAL_END = 'TRIAL_END',
  PAYMENT_OVERDUE = 'PAYMENT_OVERDUE',
  RENEW_SUBSCRIPTION = 'RENEW_SUBSCRIPTION',
}

export enum BANNER_ACTION {
  START_FREE_TRAIL = 'START_FREE_TRIAL',
  UPGRADE_PRO = 'UPGRADE_PRO',
  PAY_NOW = 'PAY_NOW',
  RENEW_SUBSCRIPTION = 'RENEW_SUBSCRIPTION',
}
